import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import railsApiService from 'services/api/rails-api-service'
import { Prescription } from 'types'

export interface PrescriptionsState {
  isLoading: boolean
  prescriptions: Prescription[]
}

const initialState: PrescriptionsState = {
  isLoading: false,
  prescriptions: []
}

export const prescriptionsSlice = createSlice({
  name: 'prescriptions',
  initialState,
  reducers: {
    resetPrescriptionsState: (state) => {
      state = initialState
      return state
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getPrescriptions.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPrescriptions.fulfilled, (state, action) => {
        state.isLoading = false
        state.prescriptions = action.payload
      })
      .addCase(getPrescriptions.rejected, (state) => {
        state.isLoading = false
        state.prescriptions = []
      })
})

export const { resetPrescriptionsState } = prescriptionsSlice.actions

export default prescriptionsSlice.reducer

export const getPrescriptions = createAsyncThunk('get-prescriptions', async (_, { rejectWithValue }) => {
  try {
    const { data } = await railsApiService.apiInstance.get<Prescription[]>('/api/v1/prescriptions')

    return data
  } catch (error) {
    return rejectWithValue(error)
  }
})
